"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = void 0;
const node_fetch_1 = __importDefault(require("node-fetch"));
const http_1 = __importDefault(require("http"));
const https_1 = __importDefault(require("https"));
const agentOptions = {
    keepAlive: true,
    keepAliveMsecs: 3500,
    scheduling: 'fifo',
};
const httpAgent = new http_1.default.Agent(agentOptions);
const httpsAgent = new https_1.default.Agent(agentOptions);
const fetch = (url, options = {}) => (0, node_fetch_1.default)(url, {
    agent: (parsedURL) => {
        if (parsedURL.protocol === 'http:') {
            return httpAgent;
        }
        return httpsAgent;
    },
    ...options,
});
exports.fetch = fetch;
//# sourceMappingURL=index.js.map